(function () {
  'use strict';

  var FEEDS = 'https://integrations.etrusted.com/';
  var MINDESTHOEHE_SHOP = 30;

  var kanalJeWidget = {};   /* Widget-Kennung → Promise<Kanal-Id> */
  var anzahlJeArtikel = {}; /* 'gtin:…' / 'sku:…' → Promise<Anzahl Bewertungen> */

  function json(url) {
    return fetch(url, { mode: 'cors', credentials: 'omit' }).then(function (r) {
      return r.ok ? r.json() : {};
    });
  }

  function kanal(widgetId) {
    if (!kanalJeWidget[widgetId]) {
      kanalJeWidget[widgetId] = json(FEEDS + 'manifests/v1/' + widgetId + '.json')
        .then(function (m) { return (m.reference && m.reference.id) || ''; });
    }
    return kanalJeWidget[widgetId];
  }

  /* Die SKU steht hexkodiert im Pfad — so ruft es auch das Widget auf. */
  function hex(text) {
    return Array.prototype.map.call(unescape(encodeURIComponent(text)), function (c) {
      return ('0' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join('');
  }

  function anzahlSku(ch, sku) {
    return json(FEEDS + 'feeds/grades/v1/channels/' + ch + '/products/sku/' + hex(sku) + '/feed.json')
      .then(function (g) { return (g.grades && g.grades.overall && g.grades.overall.count) || 0; });
  }

  function anzahlGtin(ch, gtin) {
    return json(FEEDS + 'feeds/mappings/gtin/v1/channels/' + ch + '/' + encodeURIComponent(gtin) + '/mapping.json')
      .then(function (map) {
        var skus = (map.products || []).map(function (p) { return p.sku; }).filter(Boolean);
        return Promise.all(skus.map(function (sku) { return anzahlSku(ch, sku); }))
          .then(function (zahlen) { return zahlen.reduce(function (a, b) { return a + b; }, 0); });
      });
  }

  /* Plenty-Artikelnummer (data-sku) wird direkt gezaehlt, eine GTIN ueber die
     Zuordnung GTIN -> Trusted-Shops-Artikel. Siehe snippets/kettler-ts-widget.liquid. */
  function anzahlBewertungen(widget) {
    var sku = widget.getAttribute('data-sku');
    var gtin = widget.getAttribute('data-gtin');
    var schluessel = sku ? 'sku:' + sku : 'gtin:' + gtin;
    if (!anzahlJeArtikel[schluessel]) {
      anzahlJeArtikel[schluessel] = kanal(widget.getAttribute('data-etrusted-widget-id')).then(function (ch) {
        if (!ch) return 0;
        return sku ? anzahlSku(ch, sku) : anzahlGtin(ch, gtin);
      }).catch(function () { return 0; });
    }
    return anzahlJeArtikel[schluessel];
  }

  function pruefeProdukt(block, widget) {
    if (block.dataset.tsGeprueft) return;
    block.dataset.tsGeprueft = '1';
    anzahlBewertungen(widget).then(function (n) { block.hidden = !(n > 0); });
  }

  function pruefeShop(block, widget) {
    var war = block.hidden;
    block.hidden = false;                       /* messen geht nur sichtbar */
    var hoehe = widget.getBoundingClientRect().height;
    block.hidden = hoehe < MINDESTHOEHE_SHOP;
    if (block.hidden && !war) block.hidden = true;
  }

  function pruefen() {
    document.querySelectorAll('[data-ts-block]').forEach(function (block) {
      var widget = block.matches('etrusted-widget') ? block : block.querySelector('etrusted-widget');
      if (!widget) { block.hidden = true; return; }
      if (widget.hasAttribute('data-sku') || widget.hasAttribute('data-gtin')) pruefeProdukt(block, widget);
      else pruefeShop(block, widget);
    });
  }

  /* Shop-Widgets laden asynchron und rendern nachträglich; zehn Sekunden
     Beobachtung reichen dafür und laufen dann aus. Produkt-Blöcke sind nach der
     ersten Prüfung markiert und werden nicht erneut angefragt. */
  var versuche = 0;
  var takt = setInterval(function () {
    pruefen();
    if (++versuche >= 20) clearInterval(takt);
  }, 500);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pruefen);
  } else {
    pruefen();
  }
  document.addEventListener('shopify:section:load', pruefen);
})();
